import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "auth-layout"
};
const _hoisted_2 = {
  class: "main-content"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "header-body mb-7"
};
const _hoisted_5 = {
  class: "row align-items-center"
};
const _hoisted_6 = {
  class: "col-lg-6"
};
const _hoisted_7 = {
  class: "pr-5"
};
const _hoisted_8 = {
  class: "display-2 text-white font-weight-bold mb-0"
};
const _hoisted_9 = {
  class: "col-lg-5 col-md-7",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_10 = {
  class: "card bg-light border-0 mb-0"
};
const _hoisted_11 = {
  class: "card-body px-lg-5 py-lg-6"
};
const _hoisted_12 = {
  role: "form"
};
const _hoisted_13 = {
  class: "text-center"
};
const _hoisted_14 = {
  id: "footer-main",
  class: "py-5"
};
const _hoisted_15 = {
  class: "container"
};
const _hoisted_16 = {
  class: "row align-items-center justify-content-xl-between"
};
const _hoisted_17 = {
  class: "col-lg-6"
};
const _hoisted_18 = {
  class: "copyright text-left text-muted"
};
import { login } from '@/common/validations';
import { computed, onBeforeMount, ref } from 'vue';
import BaseButton from '@/templates/argon-core/BaseButton';
import BaseInput from '@/templates/argon-core/Inputs/BaseInput.vue';
import ConstCode, { CODE_ENV_LIST, MAIN_PATH } from '@/common/constants/ConstCode';
import { useRouter } from 'vue-router';
import useVuelidate from '@vuelidate/core';
import { useAccountStore } from '@/store/modules/account';
import { useLayoutStore } from '@/store/modules/layout';
export default {
  __name: 'Login',
  setup(__props) {
    const {
      replace,
      push
    } = useRouter();
    onBeforeMount(() => {
      forgetAll();
    });
    const form = ref({
      id: '',
      password: ''
    });
    const thisYear = computed(() => new Date().getFullYear());
    const projectName = computed(() => CODE_ENV_LIST.PROJECT_NAME);
    const mainColor = computed(() => `background-color: ${ConstCode.MAIN_COLOR} !important;`);
    const v$ = useVuelidate(login, form);
    const layoutStore = useLayoutStore();
    const accountStore = useAccountStore();
    const fnLogin = async () => {
      v$.value.$touch();
      if (v$.value.$invalid) return;
      if (await accountStore.login(form.value)) {
        layoutStore.toggleDefaultLayout();
        await replace(MAIN_PATH);
      }
    };
    const forgetAll = () => {
      layoutStore.setLoginDefaultLayout();
      accountStore.accessToken = '';
      accountStore.setLoginData({
        authNo: '',
        id: '',
        joinType: '',
        role: ''
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "header pt-5 pb-7",
        style: _normalizeStyle(mainColor.value)
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("h1", _hoisted_8, _toDisplayString(projectName.value), 1), _cache[2] || (_cache[2] = _createElementVNode("h2", {
        class: "display-4 text-white font-weight-light"
      }, "LOGIN", -1))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "text-center text-muted mb-5"
      }, " LOGIN ", -1)), _createElementVNode("form", _hoisted_12, [_createVNode(BaseInput, {
        modelValue: form.value.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.id = $event),
        valid: !_unref(v$).id.$error,
        "prepend-icon": "ni ni-email-83",
        placeholder: "id",
        autocomplete: "username"
      }, null, 8, ["modelValue", "valid"]), _createVNode(BaseInput, {
        valid: !_unref(v$).password.$error,
        modelValue: form.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.password = $event),
        "prepend-icon": "ni ni-lock-circle-open",
        type: "password",
        placeholder: "Password",
        onKeyup: _withKeys(fnLogin, ["enter"]),
        autocomplete: "current-password"
      }, null, 8, ["valid", "modelValue"]), _createElementVNode("div", _hoisted_13, [_createVNode(_unref(BaseButton), {
        type: "button",
        class: "btn btn-default my-4",
        style: {
          "width": "100%",
          "background-color": "#333333",
          "border-color": "#333333"
        },
        onClick: fnLogin
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" LOGIN ")])),
        _: 1
      })])])])])])])])]), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "separator separator-bottom separator-skew zindex-100"
      }, [_createElementVNode("svg", {
        x: "0",
        y: "0",
        viewBox: "0 0 2560 100",
        preserveAspectRatio: "none",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("polygon", {
        class: "fill-default",
        points: "2560 0 2560 100 0 100",
        style: {
          "fill": "#f6f9fc"
        }
      })])], -1))], 4)]), _createElementVNode("footer", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createTextVNode(_toDisplayString(`© ${thisYear.value}`) + " ", 1), _cache[6] || (_cache[6] = _createElementVNode("a", {
        href: "https://appg.co.kr/",
        class: "font-weight-bold ml-1",
        target: "_blank",
        rel: "noopener"
      }, "APPG INC. ", -1))])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "col-lg-6"
      }, [_createElementVNode("ul", {
        class: "nav nav-footer justify-content-center justify-content-lg-end"
      }, [_createElementVNode("li", {
        class: "nav-item"
      }, [_createElementVNode("a", {
        href: "https://appg.co.kr/",
        class: "nav-link",
        target: "_blank",
        rel: "noopener"
      }, "About Us")])])], -1))])])])]);
    };
  }
};